<template>
  <div class="about"></div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  data() {
    return {
      values: {},
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    if (window.location.hash) {
      let url = window.location.hash.split('?')[1];
      let arr = url.split('&');
      arr.forEach((item) => {
        let str = item.split('=');
        this.values[str[0]] = decodeURIComponent(str[1]);
      });
    }
    console.log(this.values)
    this.setUserInfo({ ...this.values });
    this.handleGet();
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'SET_USER_INFO',
    }),
    handleGet() {
      if(this.values.parking_store_coupon_id){
        this.$router.push({
          name: 'Receive',
        });
        return
      }
      if (this.values.parking_coupon_id) {
        this.$router.push({
          name: 'CouponDetail',
        });
      } else {
        this.$router.push({
          name: 'Home',
        });
      }
    },
  },
};
</script>
